import { createGlobalStyle } from 'styled-components';
import colors from './colors';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  ::-webkit-scrollbar {
    width: 9px;
    height: 8px;
  }

  ::-webkit-scrollbar-button {
    width: 0px;
    height: 0px;
  }

  /* Normal state: 4px width with 2px transparent border padding on edges */
  ::-webkit-scrollbar-thumb {
    background:  ${colors.brand_500};
    border-radius: 10px;
    border: 2px solid transparent;
    background-clip: content-box;
    min-height: 40px;
    transition: all 0.15s ease;
  }

  /* Hover state: expands by 2px (to 6px width) and darkens */
  ::-webkit-scrollbar-thumb:hover {
    background: ${colors.brand_600};
    border: 1px solid transparent !important;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb:active {
    background: ${colors.brand_600};
    border: 1px solid transparent !important;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
    border: 0px none #ffffff;
    border-radius: 50px;
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  body {
    background: ${colors.light};
    color: ${colors.primary};
    --webkit-font-smoothing: antialiased;
  }

  body, input, button {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 500;
  }

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500;
  }

  button {
    cursor: pointer;
  }

  .mention {
    color: #000;
    font-weight: 600;
    padding: 0px 0px;
    border-radius: 4px;
    font-size: 15px;
  }
      /* Makes the progress line ends rounded and smooth */
  .MuiCircularProgress-circle {
    stroke-linecap: round !important;
  }
  
  .MuiCircularProgress-indeterminate {
    animation: mui-rotate-rad 1.4s linear infinite !important;
  }
  .MuiCircularProgress-circleIndeterminate {
    animation: mui-dash 1.4s ease-in-out infinite !important;
    stroke-dasharray: 80px, 200px !important;
    stroke-dashoffset: 0px !important;
    stroke: currentColor !important;
  }
  
  @keyframes mui-rotate-rad {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes mui-dash {
    0% {
      stroke-dasharray: 1px, 200px;
      stroke-dashoffset: 0px;
    }
    50% {
      stroke-dasharray: 89px, 200px;
      stroke-dashoffset: -35px;
    }
    100% {
      stroke-dasharray: 89px, 200px;
      stroke-dashoffset: -124px;
    }
  }

`;
